import { render, staticRenderFns } from "./ScreeningListTable.vue?vue&type=template&id=571b21e0"
import script from "./ScreeningListTable.vue?vue&type=script&lang=js"
export * from "./ScreeningListTable.vue?vue&type=script&lang=js"
import style0 from "./ScreeningListTable.vue?vue&type=style&index=0&id=571b21e0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports